import {
  Card,
  Grid,
  Select,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  Box,
  Typography,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";
import AppService from "../../../../Configurations/Appservice";

import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { useState, useEffect, useRef } from "react";

import FileField from "./panels/FileField";
import FieldText from "./panels/FieldText";
import { useDispatch } from "react-redux";
import {
  showLoader,
  dismissLoader,
  showSuccessMessage,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { updateScreenTitle } from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import WdDivider from "../../../../Components/WdDivider";
import { useLocation } from "react-router-dom";
import CustomerStatFieldInfo from "./panels/CustomerStatFieldInfo";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const initialValues = {
  description: "",
  serviceId: "",

  uid: "",
  firstNameEn: "",
  middleNameEn: "",
  lastNameEn: "",
  firstNameAr: "",
  middleNameAr: "",
  lastNameAr: "",
  nameEn: "",
  nameAr: "",
  dob: null,
  gender: null,
  passportNumber: "",
  passportIssue: "",
  passportExpiry: null,
  passportExpiry2: null,
  passportIssuePlaceEn: "",
  passportIssuePlaceAr: "",
  emiratesId: "",
  emiratesIdIssueDate: null,
  emiratesIdExpiryDate: null,
  birthPlaceEn: "",
  birthPlaceAr: "",
  birthCertificate: "",
  emirate: "",
  address: "",
  area: "",
  buildingNumber: "",
  poBox: "",
  mobileNumber: "",
  landNumber: "",
  deliveryNumber: "",
  email: "",
  fileNumber: "",
  passportCopy: "",
  visaPage: "",
  photo: "",
  shinasnama: "",
  labourContract: "",
  salaryCertificate: "",
};

const validationSchema = object({
  // description: string().required("Description is Mandatory"),
  // serviceId: string().required("Service Group is Mandatory"),
});

const dateFields = ["dob", "passportExpiry", "emiratesIdIssueDate", "emiratesIdExpiryDate"];

const EditTicket = () => {
  const [services, setServices] = useState([]);
  const [fields, setFields] = useState([]);
  const [chargeMapping, setChargeMapping] = useState();
  const [serviceName, setServiceName] = useState("");

  const [staticFields, setStaticFields] = useState([]);
  const [uploadingStaticDocs, setUploadingStaticDocs] = useState([]);

  const [file, setFile] = useState();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const ticketId = location.state?.id;
    const params = { ticketId };
    dispatch(showLoader());
    AppService.get("v1/ticket/editDetails", { params })
      .then((details) => {
        console.log(details);
        setServices(details.services);
        formikRef.current.setFieldValue("description", details.description);
        formikRef.current.setFieldValue("serviceId", details.serviceId);
        setFields(details.fields);
        setServiceName(details.serviceName);
        _doStaticFieldOperations(details);
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, []);

  const _doStaticFieldOperations = ({ staticFields }) => {
    if (!staticFields) return;
    console.log(staticFields);
    let staticFieldKeys = [];
    staticFields.forEach(({ code, value }) => {
      if (dateFields.includes(code)) {
        formikRef.current.setFieldValue(code, dayjs.utc(value, "YYYY-MM-DD").local());
      } else {
        formikRef.current.setFieldValue(code, value);
      }
      staticFieldKeys.push(code);
    });

    setStaticFields([...staticFieldKeys]);
  };

  const _onSubmit = (values, { resetForm }) => {
    const ticketId = location.state?.id;
    dispatch(showLoader());

    let obj = {};
    [...fields].forEach((field) => {
      obj[field.title] = field.value;
    });
    values.editedFields = obj;
    values.id = ticketId;

    AppService.put("v1/ticket", values)
      .then(() => {
        resetForm();
        setFields([]);
        setChargeMapping();
        dispatch(showSuccessMessage("Ticket updated Successfully"));
      })
      .catch((error) => {})
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  useEffect(() => {
    dispatch(updateScreenTitle("Edit Ticket"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  const _onTextChange = (text, field, index) => {
    let fieldsCopy = [...fields];
    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = text;
      }
    });
    setFields(fieldsCopy);
  };

  const _onFileUpload = (fileUrl, field, index) => {
    let fieldsCopy = [...fields];
    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = fileUrl;
      }
    });
    setFields(fieldsCopy);
  };

  const _onFileRemove = (field, index) => {
    let fieldsCopy = [...fields];
    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = null;
      }
    });
    setFields(fieldsCopy);
  };

  const _isFieldsAreValid = () => {
    return !fields.some((field) => field.mandatory && !field.value);
  };

  const _renderField = (field, index) => {
    if (field.type === "TEXT") {
      return (
        <Grid item xs={12}>
          <WDBox height="100%" my={1}>
            {field.type === "TEXT" ? (
              <FieldText index={index} key={field.id} field={field} onChange={_onTextChange} />
            ) : (
              <FileField
                index={index}
                key={field.id}
                field={field}
                onFileUpload={_onFileUpload}
                onFileRemove={_onFileRemove}
              />
            )}
          </WDBox>
        </Grid>
      );
    } else {
      return (
        <Grid item xs={12} md={6}>
          <WDBox height="100%">
            {field.type === "TEXT" ? (
              <FieldText index={index} key={field.id} field={field} onChange={_onTextChange} />
            ) : (
              <FileField
                index={index}
                key={field.id}
                field={field}
                onFileUpload={_onFileUpload}
                onFileRemove={_onFileRemove}
              />
            )}
          </WDBox>
        </Grid>
      );
    }
  };

  const _onStaticFieldDocUpload = (formikField) => {
    let uploadingStaticDocsCopy = [...uploadingStaticDocs];
    uploadingStaticDocsCopy.push(formikField);
    setUploadingStaticDocs(uploadingStaticDocsCopy);
  };

  const _onStaticFieldDocUploadComplete = (formikField) => {
    let uploadingStaticDocsCopy = [...uploadingStaticDocs].filter((item) => item !== formikField);
    setUploadingStaticDocs(uploadingStaticDocsCopy);
  };

  return (
    <WDBox>
      <Card sx={{ padding: 3 }}>
        <Formik
          initialValues={initialValues}
          onSubmit={_onSubmit}
          validationSchema={validationSchema}
          innerRef={formikRef}
        >
          {({ errors, isValid, touched, dirty, setFieldValue, values }) => (
            <Form>
              <WDBox>
                <WDTypography fontSize={14}>Basic Details</WDTypography>
              </WDBox>
              <WDBox my={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <WDBox>
                      <Field
                        name="description"
                        label="Ticket Description"
                        fullWidth
                        as={TextField}
                        size="small"
                        multiline
                        maxRows={2}
                        error={Boolean(errors.description) && Boolean(touched.description)}
                        helperText={Boolean(touched.description) && errors.description}
                      />
                    </WDBox>
                  </Grid>
                  <Grid item xs={12}>
                    <WDBox>
                      <FormControl fullWidth>
                        <InputLabel id="service-label">Service</InputLabel>
                        <Field
                          name="serviceId"
                          label="Service"
                          labelId="service-label"
                          size="small"
                          fullWidth
                          as={Select}
                          // onChange={(e) => onServieChange(e, setFieldValue)}
                          error={Boolean(errors.serviceId) && Boolean(touched.serviceId)}
                          helperText={Boolean(touched.serviceId) && errors.serviceId}
                        >
                          {services.map((service) => (
                            <MenuItem value={service.id}>{service.name}</MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                    </WDBox>
                  </Grid>
                </Grid>
              </WDBox>

              <Typography fontSize={14}>Customer Details</Typography>
              <CustomerStatFieldInfo
                staticFields={staticFields}
                isUidready={true}
                formikRef={formikRef}
                setFieldValue={setFieldValue}
                uploadingDocs={uploadingStaticDocs}
                onUpload={_onStaticFieldDocUpload}
                onUploadComplete={_onStaticFieldDocUploadComplete}
                formikValues={values}
              />

              <Typography fontSize={14}>More Details</Typography>
              <WDBox my={2}>
                <Grid container spacing={1}>
                  {fields
                    .filter((item) => item.type === "TEXT")
                    .map((field, index) => _renderField(field, index))}
                </Grid>
              </WDBox>
              <Typography fontSize={14}>Documents</Typography>
              <WDBox>
                <Grid container spacing={1}>
                  {fields
                    .filter((item) => item.type != "TEXT")
                    .map((field, index) => _renderField(field, index))}
                </Grid>
              </WDBox>
              {chargeMapping && (
                <WDBox my={6}>
                  <WdDivider>
                    <Typography fontSize={14}>Charges</Typography>
                  </WdDivider>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                      <Box>
                        <WDTypography variant="caption">Govt.Charge</WDTypography>
                        <WDTypography variant="h6" fontSize={14}>
                          {chargeMapping.govtCharge}
                        </WDTypography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box>
                        <WDTypography variant="caption">Service Charge</WDTypography>
                        <WDTypography variant="h6" fontSize={14}>
                          {chargeMapping.serviceCharge}
                        </WDTypography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box>
                        <WDTypography variant="caption">Tax On Service Charge</WDTypography>
                        <WDTypography variant="h6" fontSize={14}>
                          {chargeMapping.taxOnServiceCharge}
                        </WDTypography>
                      </Box>
                    </Grid>
                  </Grid>
                </WDBox>
              )}
              <WDBox display="flex" justifyContent="flex-end" pt={3}>
                <WDButton
                  variant="gradient"
                  disabled={!dirty || !isValid || !_isFieldsAreValid()}
                  type="submit"
                >
                  Submit
                </WDButton>
              </WDBox>
            </Form>
          )}
        </Formik>
      </Card>
    </WDBox>
  );
};

export default EditTicket;
